// Light / dark toggle in the footer. header.php applies the saved choice
// before first paint; this keeps the label and the stored value in sync.
import { $, t } from "./dom.js";

export function initTheme() {
  const root = document.documentElement;
  const button = $(".js-theme-toggle");
  const label = $(".js-theme-label");
  if (!button) return;

  const sync = () => {
    if (label) label.textContent = root.getAttribute("data-theme") === "dark" ? t("light") : t("dark");
  };
  sync();

  button.addEventListener("click", () => {
    const next = root.getAttribute("data-theme") === "dark" ? "light" : "dark";
    root.setAttribute("data-theme", next);
    try {
      localStorage.setItem("sd-theme", next);
    } catch (e) {
      /* ignore */
    }
    sync();
  });
}
